import React, { useState, useEffect } from 'react';
import {
  Box, CircularProgress, Typography, Paper, Alert, Button
} from '@mui/material';
import { getThing, startThingUpdatesNoJourney, stopUpdates } from './LiveApis';
import Openlayer from './openlayer';
import mainLogo from '../../../assets/images/dhundhoo_logo.png';

function Live_SingleTrack() {
  const [thingModel, setThingModel] = useState(null);
  const [error, setError] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // -----------------------------------------------------------------
  // 1. Load thing + start real-time updates
  // -----------------------------------------------------------------
  useEffect(() => {
    const authParams = new URLSearchParams(window.location.search);

    getThing(
      data => {
        setThingModel(data);
        setError(null);
        if (data.latest?.GPS?.location) setCurrentLocation(data.latest.GPS.location);
        startThingUpdatesNoJourney(loc => setCurrentLocation(loc));
      },
      err => setError(err)
    );

    const timer = setTimeout(() => setIsLoading(true), 5000);
    return () => {
      clearTimeout(timer);
      stopUpdates();
    };
  }, []);

  // -----------------------------------------------------------------
  // 2. UI
  // -----------------------------------------------------------------
  if (thingModel === null && error === null && !isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
        <Typography ml={2}>Loading tracker...</Typography>
      </Box>
    );
  }

  if (thingModel === null && error === null && isLoading) {
    return (
      <Paper elevation={3} sx={{ p: 3, textAlign: 'center', mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          If loading takes too long,
        </Typography>
        <Button variant="contained" onClick={() => window.location.reload()} sx={{ mt: 2 }}>
          Refresh
        </Button>
      </Paper>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        <Typography>{error}</Typography>
        <Button
          size="small"
          onClick={() => window.location.reload()}
          sx={{ mt: 1 }}
        >
          Refresh
        </Button>
      </Alert>
    );
  }

  // -----------------------------------------------------------------
  // 3. Only the map with the live vehicle
  // -----------------------------------------------------------------
  return (
    <Box sx={{ width: '100%', height: '100vh', position: 'relative', overflow: 'hidden' }}>
      <Openlayer position={currentLocation} />

      {/* FLOATING TOP LOGO */}
      <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
        <Paper elevation={3} sx={{ p: 0.5, borderRadius: 2, display: 'flex', alignItems: 'center', bgcolor: 'white' }}>
          <img src={mainLogo} alt="Logo" style={{ height: 35 }} />
        </Paper>
      </Box>
    </Box>
  );
}

export default Live_SingleTrack;